// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Ckin","requiredAsterisk":"Info_requiredAsterisk__3CNXP"};